<template>
    <div class="app">
        <AppHeader fixed style="background-color: #428bca">
            <SidebarToggler class="d-lg-none" display="md" mobile/>
            <b-link class="navbar-brand" to="#" style="color: #fff; font-weight: bold; width: 155px;">
                BIS-Office
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg"/>
            <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-md-down-none" @click="refresh">
                    <i class="icon-refresh" style="color: #fff;"></i>
                </b-nav-item>
                <DefaultHeaderDropdownAccnt v-if="!isExtern" @change-password="changePassword" @switch-user="switchUser" :username="username"/>
                <DownloadWindowsDropdown v-if="windows_download && !isElectron() && !isExtern"/>
                <ChangeModuleDropdown v-if="!isExtern" :modules="modules"
                                      @admin="gotoAdministration"
                                      @mobileSettings="gotoMobileSettings"
                                      @auftragsbuch="gotoAuftragsbuch"
                                      @nutzerverwaltung="gotoNutzerverwaltung"
                                      @zk="gotoZK"
                />
                <ChangeSuiteDropdown
                        v-if="showLogOn && !isExtern"
                        :suites="suites"
                        :current="mySuite"
                        @log-on="logon"/>
                <b-nav-item v-if="!isExtern" class="d-md-down-none" @click="logout">
                    <i class="icon-logout" style="color: #fff;"></i>
                </b-nav-item>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="nav" v-if="renderComponent"></SidebarNav>
                <SidebarFooter/>
                <SidebarMinimizer v-on:cui-sidebar-minimize="onMinimized"/>
            </AppSidebar>
            <main class="main" style="background-color: #fff">
                <div class="container-fluid" style="padding: 0px; height: 100%">
                    <router-view ref="router_view" :key="$route.path"></router-view>
                </div>
            </main>
        </div>
        <b-modal title="Passwort ändern" v-model="myModal" @cancel="changePasswordCancel" @ok.prevent="changePasswordOk"
                 ok-title="Ändern"
                 cancel-title="Abbrechen"
        >
            <b-container fluid>
                <b-row>
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Altes Passwort</p></b-col>
                    <b-col>
                        <b-form-input v-model="oldPwd"
                                      class="form-control text-black" type="password"
                                      v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Neues Passwort</p></b-col>
                    <b-col>
                        <b-form-input   v-model="newPwd1"
                                        class="form-control text-black" type="password"
                                        v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <p style="margin-bottom: 0; margin-top: 0.5rem;">Passwort wiederholen</p></b-col>
                    <b-col>
                        <b-form-input   v-model="newPwd2"
                                        class="form-control text-black" type="password"
                                        v-on:focus="pwdError=''"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if="pwdError !== ''"><p style="margin-top: 2rem; margin-left: 1rem; color: red;">{{pwdError}}</p></b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import nav_admin from '@/_nav_admin'
    import {
        Header as AppHeader,
        Aside as AppAside,
        AsideToggler,
        Footer as TheFooter,
        Breadcrumb
    } from '@coreui/vue'
    import {
        SidebarToggler,
        Sidebar as AppSidebar,
        SidebarFooter,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
    } from '../custom_core_ui'
    import DefaultAside from './DefaultAside'
    import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
    import DownloadWindowsDropdown from './DownloadWindowsDropdown'
    import ChangeModuleDropdown from './ChangeModuleDropdown'
    import ChangeSuiteDropdown from './ChangeSuiteDropdown'
    import {
      Cookie_Path, HUB_SERVER,
      Redirect_500,
      Redirect_Login,
      Server_URL,
      Server_URL_BASE,
      URL_AUFTRAGSBUCH, URL_MOBILE_SETTINGS, URL_NUTZERVERWALTUNG, URL_ZEITKONTROLLE
    } from "../shared/utils";
    import {encryptAESWithPw, getKey, getValue} from "../shared/crypto";
    import {CrossStorageClient} from "cross-storage"
    import {cookieDelete, storageDelete, storageSet} from "../shared/electron";


    export default {
        name: 'DefaultContainer',
        components: {
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultAside,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            DownloadWindowsDropdown,
            ChangeModuleDropdown,
            ChangeSuiteDropdown
        },

        created: function () {
            this.storage = null;
            if (this.$route.query.customer_external !== undefined && this.$route.query.customer_external !== "") {
                this.isExtern = true;
                let nav = [];
                nav.push(nav_admin.items.header);
                let massnahmenRoute = '/tasks/all';
                let massnahmenMapRoute = '/tasks/map_all';
                massnahmenRoute += "?customer_external=" + this.$route.query.customer_external + "&external_key=" + this.$route.query.external_key;
                massnahmenMapRoute += "?customer_external=" + this.$route.query.customer_external + "&external_key=" + this.$route.query.external_key;
                if (this.$route.query.permission !== undefined && this.$route.query.permission !== "") {
                    massnahmenRoute += "&permission=" + this.$route.query.permission;
                    massnahmenMapRoute += "&permission=" + this.$route.query.permission;
                }
                let massnahmenNavigation = {
                    name: 'Maßnahmen',
                        url: '/tasks',
                        icon: 'fa fa-tasks fa-md',
                        open: true,
                        children: [
                        {
                            name: 'Alle Maßnahmen',
                            url: massnahmenRoute,
                        },
                            {
                                name: 'Maßnahmen Karte',
                                url: massnahmenMapRoute,
                            },
                    ]
                };
                nav.push(massnahmenNavigation);

                this.nav = nav;

                // set the cookies for external use
                this.$cookies.set("customer_external", this.$route.query.customer_external, -1, null, Cookie_Path, true);
                this.$cookies.set("key_external", this.$route.query.external_key, -1, null, Cookie_Path, true);
                if (this.$route.query.permission !== undefined && this.$route.query.permission !== "") {
                    this.$cookies.set("permission_external", this.$route.query.permission, -1, null, Cookie_Path, true);
                }
            } else {
                if (!this.$cookies.isKey("ps")) {
                    window.location = Redirect_Login;
                    return;
                }
                // set baumkontrolle to default
                this.setCookie("ps_module", "5", -1, null, Cookie_Path, true);
                if (this.$cookies.isKey("ps_username")) {
                    this.username = this.$cookies.get("ps_username");
                }
                this.$http.get(
                    Server_URL + '/baumkontrolle/modules'
                ).then(this.responseOkGet, this.responseError)
                if (this.isElectron()) {
                    let url = window.location.href;
                    window.top.postMessage({typ: 'url', url: url}, "*");
                }
                }
            },
        data() {
            return {
                nav: [],
                renderComponent: true,
                loader: undefined,

                myModal: false,

                oldPwd: "",
                newPwd1: "",
                newPwd2: "",

                pwdError: "",
                errorEmpty: "Die Passwörter dürfen nicht leer sein.",
                errorUneven: "Die neuen Passwörter stimmen nicht überein.",
                errorInvalid: "Ihr eingegebenes Passwort ist falsch.",
                username: "Einstellungen",
                windows_download: false,
                permission: 2,
                modules: [],
                isEncrypted: false,
                showLogOn: false,
                suites: [],
                mySuite: {},
                sendable: false,
                planable: false,
                isExtern: false,
            }
        },
        methods: {

            testIframe() {
              var frame, key;

              frame = window.document.createElement('iframe');
              frame.id = "test-id";

              // Style the iframe
              frame.style['display'] = 'none';
              frame.style['position'] = 'absolute';
              frame.style['top'] = '-999px';
              frame.style['left'] = '-999px';

              window.document.body.appendChild(frame);
              frame.src = 'https://test-bisoffice.de/hub/hub.html';

              return frame;
            },
            onMinimized() {
                let time = 0;
                let interval = window.setInterval(() => {
                    if (time >= 300) {
                        window.clearInterval(interval);
                    }
                    if (this.$refs.router_view.$children.length === 1 && typeof this.$refs.router_view.$children[0].onSidebarToggle === "function") {
                        this.$refs.router_view.$children[0].onSidebarToggle();
                    }
                    time += 25;
                }, 25);
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkLogout(response) {
                this.hideLoader();
                sessionStorage.clear();
                window.location = Redirect_Login;
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.planable = response.body.planable;
                    this.sendable = response.body.sendable;
                    let nav = [];
                    nav.push(nav_admin.items.header);
                    nav.push(nav_admin.items.trees);
                    nav.push(nav_admin.items.controls);
                    if (this.planable || this.sendable) {
                        nav.push(nav_admin.items.tasks);
                    } else {
                        nav.push(nav_admin.items.tasks_unplanable);
                    }
                    this.nav = nav;
                    if (this.$cookies.get("ps_customer_number") === "admin") {
                        nav.push(nav_admin.items.config_admin);
                    } else if (response.body.permission === 9) {
                        nav.push(nav_admin.items.config);
                    }
                    this.permission = response.body.permission;
                    this.modules = response.body.modules;
                    this.mySuite = response.body.my_suite;
                    console.log(this.mySuite);
                    this.suites = response.body.suite_links;
                    console.log(this.suites);
                    if (this.isElectron() && this.suites !== null
                        && this.suites !== undefined && this.suites.length > 0) {
                        this.showLogOn = true;
                        console.log(this.showLogOn);
                    }
                    this.nav = nav;
                    this.windows_download = response.body.windows_downloadable;
                    this.isEncrypted = response.body.is_encrypted;
                    if (!this.hasModule(5)) {
                        // unauthorized
                        window.location = Redirect_500;
                    }
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                console.log(response);
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    //window.location = Redirect_500;
                }
            },
            logout () {
                if(this.isElectron()) {
                    window.top.postMessage("close", "*");
                } else {
                    this.switchUser();
                }
            },
            switchUser() {
                this.showLoader();
                cookieDelete("ps_pw");
                this.$cookies.remove("ps_pw", null, Cookie_Path);
                this.clearLinks().then(res => this.$http.post(
                    Server_URL_BASE + '/stammdaten/logout'
                ).then(this.responseOkLogout, this.responseError));
            },
            changePassword() {
                this.myModal = !this.myModal;
            },
            changePasswordOk() {
                if (this.oldPwd === '' || this.newPwd1 === '' || this.newPwd2 === '') {
                    this.pwdError = this.errorEmpty;
                    return
                } else if(this.newPwd2 !== this.newPwd1) {
                    this.pwdError = this.errorUneven;
                    return;
                }
                this.showLoader();
                if (this.isEncrypted) {
                    if (this.storage === null) {
                        this.storage = new CrossStorageClient(HUB_SERVER);
                    }
                    this.storage.onConnect().then(() => {
                        getKey(this.$cookies.get("ps_customer_number") + this.$cookies.get("ps_username") + "cert").then(res => {
                            this.storage.get(res)
                                .then(res => {
                                    getValue(res).then(res => {
                                        let cert = JSON.parse(res);
                                        encryptAESWithPw(this.newPwd1, cert.priv).then(res => {
                                            this.$http.post(
                                                Server_URL_BASE + '/stammdaten/suite/user/change_password',
                                                {pwd: this.oldPwd, new_pwd: this.newPwd1, restore: res}
                                            ).then(this.responsePwdOk, this.responsePwdError)
                                        })
                                    });
                                })
                        })
                    }).catch(err => console.log(err))
                } else {
                    this.$http.post(
                        Server_URL_BASE + '/stammdaten/suite/user/change_password',
                        {pwd: this.oldPwd, new_pwd: this.newPwd1}
                    ).then(this.responsePwdOk, this.responsePwdError)
                }
            },
            changePasswordCancel() {
                this.oldPwd = "";
                this.newPwd1 = "";
                this.newPwd2 = "";
                this.pwdError = "";
            },
            responsePwdOk(response) {
                this.hideLoader();
                this.myModal = false;
                if (this.isElectron()) {
                    this.setCookie("ps_pw", this.newPwd1, -1, null, Cookie_Path, true);
                    this.saveUserToLocalStorage(true, this.mySuite.value_2).then(res => console.log(res)).catch(res => console.log(res));;
                }
            },
            responsePwdError(response) {
                this.hideLoader();
                this.pwdError = this.errorInvalid;
            },
            refresh() {
                location.reload();
            },
            isElectron() {
                let userAgent = navigator.userAgent.toLowerCase();
                return userAgent.indexOf(' electron/') > -1;
            },
            gotoAuftragsbuch() {
                window.location = URL_AUFTRAGSBUCH;
            },
            gotoAdministration() {

            },
            gotoNutzerverwaltung() {
                window.location = URL_NUTZERVERWALTUNG;
            },
            gotoMobileSettings() {
                window.location = URL_MOBILE_SETTINGS;
            },
          gotoZK() {
            window.location = URL_ZEITKONTROLLE;
          },
            logon(event) {
                this.showLoader();
                this.saveUserToLocalStorage(false, this.mySuite.value_2).then(res => {
                    sessionStorage.clear();
                    this.hideLoader();
                    window.location = Redirect_Login+"?switch_suite="+event+"&user="+this.$cookies.get("ps_username");
                }).catch(res => {
                    console.log(res);
                    this.hideLoader();
                });
            },
            hasModule(module) {
                for (let i = 0; i < this.modules.length; i++) {
                    if (this.modules[i] === module) {
                        return true;
                    }
                }
                return false
            },
            async clearLinks() {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();
                let res = await this.storage.get("links");
                if (res === null || res === "") {
                    return
                }
                let links = JSON.parse(res);
                for (let i = 0; i < links.length; i++) {
                    storageDelete(links[i].customer_number);
                    await this.storage.del(links[i].customer_number);
                }
                storageDelete("links");
                return this.storage.del("links");

            },
            async saveUserToLocalStorage(doCheck, suiteName) {
                if (!this.isElectron()) {
                    return
                }
                if (this.storage === null) {
                    this.storage = new CrossStorageClient(HUB_SERVER);
                }
                await this.storage.onConnect();

                let res = await this.storage.get(this.$cookies.get("ps_customer_number"))
                if ((res === null || res === "") && doCheck) {
                    return;
                } else {

                    let links = [];
                    links.push({
                        customer_number: this.$cookies.get("ps_customer_number"),
                        customer_name: suiteName,
                    });

                    for (let i = 0; i < this.suites.length; i++) {
                        links.push({
                            customer_number: this.suites[i].id,
                            customer_name: this.suites[i].value_2,
                        });
                    }
                    storageSet("links", JSON.stringify(links));
                    await this.storage.set("links", JSON.stringify(links));
                    let user = {
                        user_id: this.$cookies.get("ps_user_id"),
                        username: this.$cookies.get("ps_username"),
                        pw: this.$cookies.get("ps_pw"),
                        suite_id: this.$cookies.get("ps_customer_number"),
                        suite_name: suiteName,
                    }
                    storageSet(this.$cookies.get("ps_customer_number"), JSON.stringify(user));
                    return this.storage.set(this.$cookies.get("ps_customer_number"), JSON.stringify(user))
                }

            },
            setCookie(keyName, value, expireTimes, path, domain, secure) {
                this.$cookies.set(keyName, value, expireTimes, path, domain, secure);
                if (this.isElectron()) {
                    window.top.postMessage(
                        {
                            typ: 'cookie',
                            keyName: keyName,
                            value: value,
                            expireTimes: expireTimes,
                            path: path,
                            domain: domain,
                            secure: secure
                        }, "*");
                }
            },

        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            }
        }
    }
</script>

<style scoped>
    .breadcrumb {
        margin-bottom: 0rem;
    }
</style>
